import { render, staticRenderFns } from "./IconStage.vue?vue&type=template&id=498e2c3c&"
import script from "./IconStage.vue?vue&type=script&lang=js&"
export * from "./IconStage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports